import React from 'react'
import { Link } from 'react-router-dom'

const CampaignCard = ({ item, type }) => {
  const id = item?.campaign_id ?? item?.id;

  return (
    <Link to={`/campaigns-analytics/${id}`}>
      <div className='max-w-[205px] h-96 border rounded-2xl relative overflow-hidden min-w-[205px]'>
        <img
          src={item?.campaign_poster}
          alt=''
          className='object-cover w-full h-[80%]'
        />
        {type === 'top' && (
          <img
            src={item?.customer_logo_image_thumbnail}
            alt={item?.customer_name}
            style={{ width: 30, height: 30, borderRadius: '50%', objectFit: 'contain', objectPosition: 'center' }}
            className='absolute top-2 left-2'
          />
        )}
        <div className='h-[20%] w-full p-2'>
          {type === 'top' ? (
            <div className='flex flex-col items-center'>
              <h6 className='m-0'>{item?.campaign_name}</h6>
              <p className='m-0'>Reported Links : {item?.reported?.toLocaleString()}</p>
            </div>
          ) : (
            <div className='flex flex-col gap-2'>
              <h6 className='m-0'>{item?.campaign_name}</h6>
              {(item?.status_label ?? item?.status) === 'Active' || item?.status === true ? (
                <span className='badge bg-success'>Active</span>
              ) : (
                <span className='badge bg-warning'>InActive</span>
              )}
            </div>
          )}
        </div>
      </div>
    </Link>
  )
}

export default CampaignCard
